export default __webpack_public_path__ + "static/media/objectsRain.38d6ebd3.png";